import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";
import { PanelBody, PanelRow, ToggleControl, SelectControl, RangeControl, __experimentalNumberControl as NumberControl } from "@wordpress/components";
import { BControlPro } from "../../../../../../../wp-utils/v1/components";

const Options = ({ attributes, setAttributes }) => {
  const { animation, autoRotate, autoplay, exposure, fullscreen, lazyLoad, loadingPercentage, model, multiple, models, mouseControl, progressBar, rotate, rotateAlongX, rotateAlongY, rotationPerSecond, selectedAnimation, shadow, uniqueId, variant, isPagination, isNavigation, isPremium } = attributes;

  const [animations, setAnimations] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      document.querySelector(`#${uniqueId} model-viewer`)?.addEventListener("load", function () {
        const animations = this.availableAnimations.map((animation) => {
          return { label: animation, value: animation };
        });
        setAnimations([...animations, { label: "None", value: "" }]);
      });
    }, 0);
  }, [uniqueId, model, models, multiple]);

  return (
    <>
      <PanelBody title={__("Options", "b3d-viewer-lite")}>
        <ToggleControl label={__("Fullscreen", "b3d-viewer-lite")} checked={fullscreen} onChange={() => setAttributes({ fullscreen: !fullscreen })} />

        {["gltf", "glb"].includes(model.ext || "glb") && (
          <>
            <ToggleControl label={__("Mouse Control", "b3d-viewer-lite")} checked={mouseControl} onChange={() => setAttributes({ mouseControl: !mouseControl })} />

            <ToggleControl label={__("Lazy Load", "b3d-viewer-lite")} checked={lazyLoad} onChange={() => setAttributes({ lazyLoad: !lazyLoad })} />

            <ToggleControl label={__("Show Loading Percentage", "b3d-viewer-lite")} checked={loadingPercentage} onChange={() => setAttributes({ loadingPercentage: !loadingPercentage })} />

            <ToggleControl label={__("Show Progressbar", "b3d-viewer-lite")} checked={progressBar} onChange={() => setAttributes({ progressBar: !progressBar })} />

            <BControlPro Component={ToggleControl} isPremium={isPremium} label={__("Enable Shadow", "b3d-viewer-lite")} checked={shadow} onChange={() => setAttributes({ shadow: !shadow })} />

            <BControlPro isPremium={isPremium} label={__("Autoplay ( if animated )", "b3d-viewer-lite")} Component={ToggleControl} checked={autoplay} onChange={() => setAttributes({ autoplay: !autoplay })} />

            <BControlPro isPremium={isPremium} label={__("Enable Variant Selector", "b3d-viewer-lite")} Component={ToggleControl} checked={variant} onChange={() => setAttributes({ variant: !variant })} />

            <BControlPro isPremium={isPremium} label={__("Enable Animation Selector", "b3d-viewer-lite")} Component={ToggleControl} checked={animation} onChange={() => setAttributes({ animation: !animation })} />

            {animation && animations.length !== 0 && !multiple && (
              <PanelRow>
                <label>{__("Set Animation", "b3d-viewer-lite")}</label>
                <SelectControl options={animations} value={selectedAnimation} onChange={(selectedAnimation) => setAttributes({ selectedAnimation })} />
              </PanelRow>
            )}

            <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("Auto Rotate", "b3d-viewer-lite")} checked={autoRotate} onChange={() => setAttributes({ autoRotate: !autoRotate })} />

            {autoRotate && (
              <>
                <PanelRow>
                  <label>{__("Rotate Per Second (deg)", "b3d-viewer-lite")}</label>
                  <NumberControl value={rotationPerSecond} onChange={(rotationPerSecond) => setAttributes({ rotationPerSecond })} />
                </PanelRow>
              </>
            )}
            {!multiple && (
              <>
                <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("Rotate Direction", "b3d-viewer-lite")} checked={rotate} onChange={() => setAttributes({ rotate: !rotate })} />

                {rotate && (
                  <>
                    <PanelRow>
                      <label>{__("Rotate Along X", "b3d-viewer-lite")}</label>
                      <NumberControl onChange={(value) => setAttributes({ rotateAlongX: parseInt(value) })} value={rotateAlongX} max={360} min={0} />
                    </PanelRow>
                    <PanelRow>
                      <label>{__("Rotate Along Y", "b3d-viewer-lite")}</label>
                      <NumberControl onChange={(value) => setAttributes({ rotateAlongY: parseInt(value) })} value={rotateAlongY} max={360} min={0} />
                    </PanelRow>
                  </>
                )}
              </>
            )}
            <BControlPro isPremium={isPremium} Component={RangeControl} label={__("Exposure", "b3d-viewer-lite")} value={exposure} onChange={(exposure) => setAttributes({ exposure })} min={0.1} step={0.1} max={10} />
            {(multiple || !isPremium) && (
              <>
                <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("show thumbnails list", "b3d-viewer-lite")} checked={isPagination} onChange={() => setAttributes({ isPagination: !isPagination })} />

                <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("show arrow", "b3d-viewer-lite")} checked={isNavigation} onChange={() => setAttributes({ isNavigation: !isNavigation })} />
              </>
            )}
          </>
        )}
      </PanelBody>
    </>
  );
};

export default Options;
